module.exports = __webpack_public_path__ + "img/ic_ab_lead_big@2x.0236b0ae.png";